import { render, staticRenderFns } from "./SecondaryTypeCard.vue?vue&type=template&id=0912e752&scoped=true"
import script from "./SecondaryTypeCard.vue?vue&type=script&lang=ts"
export * from "./SecondaryTypeCard.vue?vue&type=script&lang=ts"
import style0 from "./SecondaryTypeCard.vue?vue&type=style&index=0&id=0912e752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0912e752",
  null
  
)

export default component.exports